/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : MSAAddSerialNumber.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Deepthi B (E844276)
*
* @Date         : Oct 18, 2019
*
* @Version      : Version 1.0
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 18, 2019
* Description  : Updated code as per ASDS-404
*
* By            : E807238
* On            : Nov 4, 2019
* Description   : ASDS-1673: Add To Cart Conformation UI & Integration
*
* By           : H224423
* On           : Nov 28, 2019
* Description  : ASDS-1474 Accept product terms changes.
*
* By            : Deepthi Bachu - E844276
* On            : 28 Nov, 2019
* Description   : ASDS-1961 - loader/message while loading contract numbers in APU MSA flow
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Contracts and sub-products API error handling.
 *
 * By             : H422337
 * On             : Sep 14,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 10,2020
 * Description    : ASDS-3140 UI enhancements  phase-2 bugfixes
 *
 * By             : H422337
 * On             : Sep 21,2020
 * Description    : ASDS-2750 UI enhancements as part of phase-2
 *
 * By            : H422337
 * On            : Sep 25, 2020
 * Description   : ASDS - 3225- Bug fixes for Phase - II
 *
 * By            : H422337
 * On            : Oct 15, 2020
 * Description   : ASDS - 3561-UI enhancements  for Phase - II
 *
 * By            : H422337
 * On            : Nov 18, 2020
 * Description   : ASDS - 4073 - selection checkbox bug fixes - Phase-2
 *
******************************************************************************/
import * as React from 'react';
import { Grid, Card, Notification, Select, Icon, Input } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import '@scuf/datatable/honeywell/theme.css';
import './addAPUSerialNumbers.css';
import './ConfigureAPU.css';
import { connect } from 'react-redux';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import AcceptTermsCheck from '../Common/AcceptTermsCheck';
import { CheckoutUILabels, ApuErrorLabels } from '../constants/checkout-constants';
import { InLineLoader } from '../Loader/Loader';
import { ContactUsMessage } from '../Common/ContactUsMessage';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import ApuOrderApiActions from '../redux/actions/apu-order-api-actions';
interface IMSAProductDatas {
    productId: string;
    productDatas:  IMSAProductData[];
    deleteRow: Function;
    addNewRow: Function;
    updateSerial: Function;
    updateAircraftOem: Function;
    updateSoldTo: Function;
    updateContractNo: Function;
    contractDataOptions: any;
    updateAcceptTermsStatus: Function;
    acceptTermsStatus: boolean;
    acceptTermsErrorMsg: string;
    isContractDataFetching: boolean;
    isContractDataSuccess: boolean;
    isProductFetching: boolean;
    isProductFetchSuccess: boolean;
    getContractDetails: Function;
    getSubProductDetails: Function;
    hideAPUValidationErrMsg: Function;
    showAPUValidationErrorMsg: boolean;
}

interface IMSAProductData {
    soldTo: string;
    soldToError: string;
    contractNo: string;
    contractNumError: string;
    expirationDate: string;
    aircraftOem: string;
    aircraftOemError: string;
    serialNumber: string;
    serialNumberError: string;
}

class MSAAddSerialNumber extends React.Component<IMSAProductDatas, any> {

    constructor(props: IMSAProductDatas) {
        super(props);
        this.state = {
            selectedRowData : [] as any
        };
        this.handleRetry = this.handleRetry.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
    }

    handleRetry() {
        if (!this.props.isContractDataFetching && !this.props.isContractDataSuccess) {
            this.props.getContractDetails();
        }
        if (!this.props.isProductFetching && !this.props.isProductFetchSuccess) {
            this.props.getSubProductDetails(this.props.productId);
        }
    }
    rowExpansionTemplate(data){
        let errorMsg: string = '';
        let errorTitle: string = '';


        if (data.serialNumberError !== '') {
   errorMsg = data.serialNumberError;
   if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_EMPTY){
   errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
        }
   else if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_INVALID){
        errorTitle = ApuErrorLabels.SERIAL_NUMBER_INVALID;
   }
   else {
       errorTitle = ApuErrorLabels.SERIAL_NUMBER_DUBLICATE;
   }
}
        if (data.contractNumError !== '') {
    errorMsg = data.contractNumError;
    if (errorMsg === ApuErrorLabels.MSA_CONTRACT_ERROR) {
    errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
         }
 }
        if (this.props.showAPUValidationErrorMsg) {
        if (errorTitle === ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR ){
        return  <Notification hasIcon={true} severity="important"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(false); }} >{errorMsg}</Notification>;
       }
       else {
           return  <Notification hasIcon={true} severity="critical"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(false); }}  >{errorMsg}</Notification>;
       }
    }
    else {
           return <span></span>
       }
}
componentDidMount() {
    const {getApuOrderData}: any = this.props;
    getApuOrderData(this.props.productId);
  }
    render() {
        const flag = ((!this.props.isContractDataFetching && this.props.isContractDataSuccess) && (!this.props.isProductFetching && this.props.isProductFetchSuccess)) && (this.props.contractDataOptions != "");
        const Item = DataTable.ActionBar.Item;
        let ErrorRowData = this.props.productDatas.filter((product: any) => {
            if (typeof product.validInputData  !== 'undefined' && !product.validInputData && (product.serialNumberError !== ''  || product.contractNumError !== '')){
                return product;
            }
    });
        return(
            <React.Fragment>
                <Card className="fullwidthCard">
                    <Card.Content>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={12} className="fullwidthRow msa-flow-panel add-serial-no">
                                        {(this.props.isContractDataFetching || this.props.isProductFetching) &&
                                            <InLineLoader text="Loading Contract Details" loading={true} overlayColor="transparent" inlineclassname="msa-configure-loader"> </InLineLoader>
                                        }
                                        {((!this.props.isContractDataFetching && !this.props.isProductFetching) && (!this.props.isContractDataSuccess || !this.props.isProductFetchSuccess)) &&
                                            <Notification
                                                hasIcon={true}
                                                title={'There is an error in processing your request.'}
                                                severity="critical"
                                                detailsText="Retry"
                                                onDetailsClick={this.handleRetry}
                                            />
                                        }
                                        {(!this.props.isContractDataFetching && !this.props.isProductFetching && this.props.isContractDataSuccess && this.props.contractDataOptions == "") &&
                                            <Notification
                                                hasIcon={true}
                                                title={'No active MSA Contract found'}
                                                severity="critical"
                                            ><ContactUsMessage>{"The selected Sold To does not have an active MSA contract. Please change the Sold To in the Select Account Screen. If you need any help,"}</ContactUsMessage>
                                            </Notification>
                                        }
                                    { flag &&
                                        <DataTable
                                            data={this.props.productDatas}
                                            onEdit={(newVal: any, cellData: ICellData) => this.updateSerialNumber(newVal, cellData)}
                                            selection={this.state.selectedRowData}
                                            selectionMode="multiple"
                                            onSelectionChange={(e) => this.setState({ selectedRowData: e })}
                                            expandedRows={ ErrorRowData }
                                            rowExpansionTemplate={this.rowExpansionTemplate}
                                        >
                                                <DataTable.HeaderBar>
                                                        <DataTable.HeaderBar.Item
                                                            content="Add"
                                                            iconSize="small"
                                                            icon="slidercontrols-plus"
                                                            onClick={() => this.addAPUMultipleRow()}
                                                        />
                                                </DataTable.HeaderBar>
                                                <DataTable.ActionBar>
                                                    <Item
                                                        icon={<Icon name="delete" root="common" size="small" />}
                                                        content="Delete"
                                                        onClick={() => this.deleteMultipleItems()}
                                                    />
                                                </DataTable.ActionBar>
                                                <DataTable.Column field="soldTo" header="Sold To Number"  align="left" />
                                                <DataTable.Column field="contractNo" header="Contract Number" align="left" renderer={(cellData) => this.contractNumberRenderer(cellData)}/>
                                                <DataTable.Column field="expirationDate" header="Expiration Date"  align="left"/>
                                                <DataTable.Column field="aircraftOem" header="APU Model"  align="left"/>
                                                <DataTable.Column field="serialNumber" header="APU Serial Number" align="left" renderer={(cellData) => this.serialNumberRenderer(cellData)}/>
                                        </DataTable>
    }

                                </Grid.Column>
                            </Grid.Row>
                            { flag &&
                             <Grid.Row>
                                <Grid.Column className='msa-add-serial-confirm-checkbox'>
                                    <AcceptTermsCheck updateAcceptTermsStatus={this.props.updateAcceptTermsStatus} acceptTermsStatus={this.props.acceptTermsStatus} acceptTermsErrorMsg={this.props.acceptTermsErrorMsg} checkboxLabel={CheckoutUILabels.APU_PRODUCT_TERMS_LABEL} />
                                </Grid.Column>
                            </Grid.Row>
                            }
                        </Grid>

                    </Card.Content>
                </Card>
            </React.Fragment>
        );
    }

    serialNumberRenderer(cellData: ICellData) {
        return (
            <Input placeholder="Enter serial number" disabled={false} type="string" className="datatable-text-input" fluid={true}  value={cellData.rowData.serialNumber} onChange={(newVal: string) => this.updateSerialNumber(newVal, cellData)} />
        );
    }

    contractNumberRenderer(cellData: ICellData) {
        return (
          <Select
            key={cellData.rowIndex}
            className="contract-number-dropdown"
            placeholder="Enter or Select Contract Number"
            value={cellData.rowData.contractNo}
            search={true}
            onChange={(value: any) => { this.updateContractNumber(value, cellData); }}
            options={this.props.contractDataOptions}
          />
        );
    }

    addAPUMultipleRow(): void {
        this.props.hideAPUValidationErrMsg(true);
        this.props.addNewRow(0);
    }

    updateSerialNumber(newVal: any, cellData: ICellData): void {
        this.props.hideAPUValidationErrMsg(true);
        this.props.updateSerial(newVal, cellData.rowIndex);
        this.updateSelectedRowData(cellData);

    }

    deleteMultipleItems(): void {
        this.props.deleteRow(this.state.selectedRowData);
        this.setState({ selectedRowData: [] });
        if (this.props.productDatas.length === this.state.selectedRowData.length) {
            this.props.addNewRow(0);
        }
    }

    updateContractNumber(value: any, cellData: ICellData) : void {
        this.props.hideAPUValidationErrMsg(true);
        this.props.updateContractNo(value, cellData.rowIndex);
        this.updateSelectedRowData(cellData);
    }

    updateSelectedRowData(cellData: ICellData) {
        if (this.state.selectedRowData.length !== 0) {
            const indexFromSelectedRowData = this.state.selectedRowData.findIndex((x: any) => (x.contractNo === cellData.rowData.contractNo) && (x.serialNumber === cellData.rowData.serialNumber));
            if (indexFromSelectedRowData !== -1) {
                    let  selecedData = [...this.state.selectedRowData];
                    selecedData.splice(indexFromSelectedRowData, 1);
                    this.setState({selectedRowData: selecedData});
            }
        }
    }
}

const mapDispatchToProps = {
    addNewRow: ConfigureAPUActions.addMSARow,
    deleteRow: ConfigureAPUActions.deleteMSARow,
    updateSerial: ConfigureAPUActions.updateMSASerial,
    updateAircraftOem: ConfigureAPUActions.updateMSAAircraftOem,
    updatePurchaseType: ConfigureAPUActions.updatePurchaseType,
    updateSoldTo: ConfigureAPUActions.updateSoldTo,
    updateContractNo: ConfigureAPUActions.updateContractNo,
    updateAcceptTermsStatus: ConfigureAPUActions.updateAcceptTermsStatus,
    getContractDetails: ConfigureAPUActions.getContractDetails,
    getSubProductDetails: ConfigureAPUActions.getSubProductDetails,
    hideAPUValidationErrMsg : ConfigureAPUActions.hideAPUValidationErrorMsg,
    getApuOrderData: ApuOrderApiActions.getApuOrderData
};

function mapStateToProps(state) {
    const payloadObj = state.configAPUData.payload;
    return {
        productDatas: payloadObj.msaConfigData,
        contractDataOptions: payloadObj.contractData,
        acceptTermsStatus: payloadObj.acceptTermsStatus,
        acceptTermsErrorMsg: payloadObj.acceptTermsErrorMsg,
        isContractDataFetching: payloadObj.isContractDataFetching,
        isContractDataSuccess: payloadObj.isContractDataSuccess,
        isProductFetching: payloadObj.isProductFetching,
        isProductFetchSuccess: payloadObj.isProductFetchSuccess,
        showAPUValidationErrorMsg: payloadObj.showAPUValidationErrorMsg,
        orderData: state.apuOrderDetails?.apuOrderDetails
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MSAAddSerialNumber);
